module.exports = __webpack_public_path__ + "img/z1.92b32908.png";